<template>
  <v-card>
    <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
      {{ type.name }}: задание "{{ item.name }}"
    </v-card-title>

    <v-list dense>
      <v-list-item v-if="item.group" dense>
        <v-list-item-content>Группа: {{ item.group.id ? item.group.title : "Без группы" }}</v-list-item-content>
      </v-list-item>
      <v-list-item dense>
        <v-list-item-content>Тип: {{ type.name }}</v-list-item-content>
      </v-list-item>
      <v-list-item v-if="doctor" dense>
        <v-list-item-content>Автор: {{ doctor.fullName }}</v-list-item-content>
      </v-list-item>
    </v-list>

    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">
                Названия
              </th>
              <th class="text-left">
                Заболевание
              </th>
              <th class="text-left">
                Когда?
              </th>
              <th class="text-center">
                Критичность
              </th>
              <th class="text-center">
                <div>Ограничить сбор</div>
              </th>
              <th class="text-center">
                Начало задания
              </th>
              <th class="text-center">
                Конец задания
              </th>
              <th class="text-center">
                Пожизненно?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                {{ item.name }}
              </td>
              <td class="">
                <span v-if="item.diseases">{{ item.diseases.name }}</span>
                <div v-else>-</div>
              </td>
              <td>
                <div>
                  {{ item.periodicity.name }}
                </div>
              </td>

              <td class="">
                <div class="d-flex justify-center align-center">
                  <v-checkbox readonly v-model="item.critical"></v-checkbox>
                </div>
              </td>
              <td class="">
                <div class="d-flex justify-center align-center">
                  <v-checkbox readonly v-model="item.limited"></v-checkbox>
                </div>
              </td>

              <td class="">
                {{ $date(item.startAt).format("DD.MM.YYYY") }}
              </td>
              <td class="">
                {{ item.endAt ? $date(item.endAt).format("DD.MM.YYYY") : "" }}
              </td>

              <td class="">
                <div class="d-flex justify-center align-center">
                  <v-checkbox readonly v-model="item.lifelong"></v-checkbox>
                </div>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-subtitle class="text-h4 font-weight-bold">Комментарий</v-card-subtitle>
    <v-card-text>{{ item.comment ? item.comment : "отсутствует" }}</v-card-text>

    <v-card-subtitle class="text-h4 font-weight-bold">Список измерений</v-card-subtitle>
    <v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th>Дата</th>
              <th>Значения</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(row, idx) in item.list">
              <tr v-if="row.date && row.value !== ''" :key="`list-index-${idx}`">
                <td>{{ row.date }}</td>
                <td>
                  <TaskValue :data="row" />
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-actions>
      <v-btn type="button" color="error" text @click="deleteTask" :loading="deleteLoading">Удалить задание</v-btn>
      <v-spacer></v-spacer>
      <v-btn type="button" color="primary" text @click="$emit('submit')">Закрыть</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import Pps from "@/views/pages/tasks/components/Pps.vue";
import Measure from "@/views/pages/tasks/components/Measure.vue";
import DatePicker from "@/components/forms/DatePicker.vue";
import TimePicker from "@/components/forms/TimePicker.vue";
import { TasksRepository } from "@/modules/tasks/tasks.repository.js";
import TaskValue from "@/views/pages/tasks/components/TaskValue.vue";
import { DoctorsRepository } from "@/modules/doctors/doctors.repository.js";

export default {
  name: "ShowTaskItem",

  components: { TaskValue, Pps, Measure, DatePicker, TimePicker },

  props: {
    type: {
      type: Object,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    onDelete: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      /** @type {Doctor|null} */
      doctor: null,
      deleteLoading: false,
    };
  },

  computed: {},

  async created() {
    this.doctor = await DoctorsRepository.getById(this.item.authorId);
  },

  methods: {
    async deleteTask() {
      this.deleteLoading = true;
      const result = await TasksRepository.delete(this.$store.state.customer.id, this.item.id);
      this.deleteLoading = false;

      if (result) {
        this.$dialog.notify.success(`Задание "${this.item.name}" удаленно`);
        this.onDelete();
        this.$emit("submit");
        return;
      }

      this.$dialog.notify.error(`Ошибка удаления задания "${this.item.name}"`);
    },
  },
};
</script>

<style scoped></style>
